<app-dialog
  [isVisible]="visible"
  [dialogHeader]="header"
  [settings]="settings"
  [emitOnShow]="true"
  [emitOnHide]="true"
  (dialogShow)="handleDialogShow()"
  (dialogHide)="handleDialogHide()"
>
  @let inputClass = "flex flex-column gap-spacing-default";
  <div class="deadzone-details">
    <div class="details-card">
      <div class="details-row">
        <div [class]="inputClass">
          <label class="input-label label-large-medium" for="dz-state"
            >State</label
          >
          <div class="k-input-wrapper">
            <input
              id="dz-state"
              class="p-inputtext"
              type="text"
              disabled
              [value]="details?.state || 'Unknown'"
              pInputText
            />
          </div>
        </div>

        <div [class]="inputClass">
          <label class="input-label label-large-medium" for="dz-location"
            >Location</label
          >
          <div class="k-input-wrapper">
            <input
              id="dz-location"
              class="p-inputtext"
              type="text"
              disabled
              [value]="details?.location || 'Unknown'"
              pInputText
            />
          </div>
        </div>
      </div>
      <div class="details-row">
        <div [class]="inputClass">
          <label class="input-label label-large-medium" for="dz-avg-strength"
            >Average Strength</label
          >
          <div class="k-input-wrapper">
            <input
              id="dz-avg-strength"
              class="p-inputtext"
              type="text"
              disabled
              [value]="details?.averageStrength ?? 0"
              pInputText
            />
          </div>
        </div>

        <div [class]="inputClass">
          <label class="input-label label-large-medium" for="dz-total-incidents"
            >Total incident</label
          >
          <div class="k-input-wrapper">
            <input
              id="dz-total-incidents"
              class="p-inputtext"
              type="text"
              disabled
              [value]="details?.totalIncidents ?? 0"
              pInputText
            />
          </div>
        </div>
      </div>
      <div class="details-row">
        <div [class]="inputClass">
          <label class="input-label label-large-medium" for="dz-period"
            >Period</label
          >
          <div class="k-input-wrapper">
            <input
              id="dz-period"
              class="p-inputtext"
              type="text"
              disabled
              [value]="formatPeriod(details?.period)"
              pInputText
            />
          </div>
        </div>
        <div [class]="inputClass">
          <label class="input-label label-large-medium" for="dz-radius"
            >Radius</label
          >
          <div class="k-input-wrapper">
            <input
              id="dz-radius"
              class="p-inputtext"
              type="text"
              disabled
              [value]="(details?.radiusMiles ?? 0) + ' mi'"
              pInputText
            />
          </div>
        </div>
      </div>
    </div>
    <div class="affected-rides-title">Affected Rides</div>
    <div class="deadzone-table-card">
      <app-basic-table
        [tableData]="tableData()"
        [showIndex]="showIndex"
      ></app-basic-table>
    </div>
  </div>
</app-dialog>
